/**
 * Chip de estado de configuración — siempre visible mientras se conversa con Galia.
 * Muestra Nivel MCER · Funcionalidad · Personalidad y al hacer clic abre el panel
 * de configuración (ver App.tsx, showSettingsPanel).
 */

import { UserConfiguration } from '../../types';
import './ConfigChip.css';

interface ConfigChipProps {
  configuration: UserConfiguration;
  onClick: () => void;
}

export function ConfigChip({ configuration, onClick }: ConfigChipProps) {
  const { mcerLevel, functionalityType, personalityType, rasgo, mode } = configuration;
  const personality = personalityType || rasgo;
  const isAideProf = mode === 'actividades-docente';

  return (
    <button
      type="button"
      className="config-chip"
      onClick={onClick}
      aria-label={isAideProf ? 'Modifier la configuration' : 'Cambiar configuración'}
      title={isAideProf ? 'Modifier la configuration' : 'Cambiar configuración'}
    >
      {isAideProf ? (
        <span className="config-chip-text">Mode assistante</span>
      ) : (
        <>
          <span className="config-chip-pill config-chip-pill--level">{mcerLevel}</span>
          <span className="config-chip-sep">·</span>
          <span className="config-chip-text">{functionalityType}</span>
          <span className="config-chip-sep">·</span>
          <span className="config-chip-text">{personality}</span>
        </>
      )}
      <svg
        className="config-chip-icon"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
      </svg>
    </button>
  );
}
